module.exports = __webpack_public_path__ + "bc42596badf901331695dd1f6b337fbb.svg";